export default [
  // 成绩
  {
    path: '/score',
    name: 'Score',
    component: () => import(/* webpackChunkName: "Score" */ '../views/Score/index.vue')
  },
  // 个人成绩详情
  {
    path: '/scoreDetail',
    name: 'ScoreDetail',
    component: () => import(/* webpackChunkName: "ScoreDetail" */ '../views/Score/ScoreDetail/scoreDetail.vue')
  },
  // 成绩详情
  {
    path: '/homeworkDetail',
    name: 'HomeworkDetail',
    component: () => import(/* webpackChunkName: "HomeworkDetail" */ '../views/Score/Homework/HomeworkDetail.vue')
  },
  // 打分
  {
    path: '/setScore',
    name: 'SetScore',
    component: () => import(/* webpackChunkName: "SetScore" */ '../views/Score/SetScore/SetScore.vue')
  }
];
